import { render, staticRenderFns } from "./MatchesCard.vue?vue&type=template&id=766e4e3d&"
import script from "./MatchesCard.vue?vue&type=script&lang=js&"
export * from "./MatchesCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports